import { cn as e } from "../../lib/utils.es.js";
import { Button as t } from "../ui/button.es.js";
import { UserAvatar as n } from "../UserAvatar/UserAvatar.es.js";
import { DataTableColumnHeader as r } from "./DataTableColumnHeader.es.js";
import { ChevronDown as i } from "lucide-react";
import { Fragment as a, jsx as o, jsxs as s } from "react/jsx-runtime";
// libs/ui-lib/src/components/DataTable/DataTableParts.tsx
var c = "flex h-10 items-center bg-muted px-4 text-left font-medium text-foreground text-sm leading-5", l = "inline-flex items-center rounded-full bg-secondary px-2 py-0.5 font-medium text-foreground text-xs";
function u({ column: t, title: n, children: i, className: a, ...s }) {
	return /* @__PURE__ */ o("div", {
		className: e(c, a),
		...s,
		children: t && n ? /* @__PURE__ */ o(r, {
			column: t,
			title: n
		}) : i ?? n
	});
}
function d({ table: e, title: n }) {
	return /* @__PURE__ */ o(t, {
		type: "button",
		variant: "ghost",
		size: "sm",
		className: "h-auto justify-start rounded-none px-0 py-0 font-medium text-foreground text-sm leading-5 hover:bg-transparent hover:text-foreground",
		onClick: () => e.resetSorting(),
		children: /* @__PURE__ */ o("span", { children: n })
	});
}
function f({ children: t, className: n, flex: r = !1, muted: i = !1, numeric: a = !1, ...s }) {
	return /* @__PURE__ */ o("div", {
		className: e(r ? "flex min-w-0 items-center px-4" : "px-4", i ? "text-muted-foreground" : "text-foreground", "text-sm", a && "tabular-nums", n),
		...s,
		children: t
	});
}
function p({ children: t, className: n, ...r }) {
	return /* @__PURE__ */ o("div", {
		className: e("flex justify-end px-4", n),
		...r,
		children: t
	});
}
function m({ children: t, className: n, muted: r = !1, ...i }) {
	return /* @__PURE__ */ o("span", {
		className: e(l, r && "text-muted-foreground", n),
		...i,
		children: t
	});
}
function h({ name: t, email: r, seed: i, meta: a, className: c, ...l }) {
	return /* @__PURE__ */ s("div", {
		className: e("flex min-w-0 items-center gap-2", c),
		...l,
		children: [/* @__PURE__ */ o(n, {
			name: t,
			email: r,
			seed: i,
			size: "sm"
		}), a ? /* @__PURE__ */ o("span", {
			className: "min-w-0 truncate text-foreground text-sm tabular-nums",
			children: a
		}) : null]
	});
}
function g({ value: t, onClick: n, ariaLabel: r, icon: i, className: c, ...l }) {
	let u = t === 0 ? /* @__PURE__ */ o("span", {
		className: "text-muted-foreground",
		children: "—"
	}) : /* @__PURE__ */ s(a, { children: [i, /* @__PURE__ */ o("span", { children: t })] }), d = t > 0 && !!n;
	return /* @__PURE__ */ o(f, {
		numeric: !0,
		className: e("flex items-center justify-center gap-1.5", c),
		...l,
		children: d ? /* @__PURE__ */ o("button", {
			type: "button",
			onClick: n,
			"aria-label": r,
			className: "inline-flex items-center gap-1.5 font-medium text-foreground text-sm tabular-nums hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/40",
			children: u
		}) : u
	});
}
function _({ expanded: n, onToggle: r, label: a, className: s }) {
	return /* @__PURE__ */ o(t, {
		type: "button",
		variant: "ghost",
		size: "sm",
		"aria-expanded": n,
		"aria-label": a ?? (n ? "Collapse row" : "Expand row"),
		onClick: r,
		className: e("size-7 rounded-md p-0 text-muted-foreground hover:bg-muted hover:text-foreground", s),
		children: /* @__PURE__ */ o(i, {
			className: e("size-4 transition-transform", n && "rotate-180"),
			"aria-hidden": "true"
		})
	});
}
export { p as DataTableActionsCell, f as DataTableCellContent, g as DataTableCountCell, _ as DataTableExpandToggle, u as DataTableHeaderCell, m as DataTablePill, d as DataTableResetSortHeader, h as DataTableUserCell, c as dataTableHeaderCellClass, l as dataTablePillClass };
